import React, { useEffect, Suspense } from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import LoadBackdrop from '../Components/Backdrop';

const ProtectedRoutes = ({ component: Component, isPrivate, ...rest }) => {

    const session = useSelector((state) => state.session);
    return (
        <Route
            {...rest}
            render={(props) => {
                
                    if (isPrivate && session?.token == null && !session?.islogged) {
                        return <Redirect to={{ pathname: "/" }} />
                    } else if (!isPrivate && session?.token !== null && session?.isLogged) {
                        return <Redirect to={{ pathname: "/dashboard" }} />
                    }
                    return (
                        <Suspense fallback={<LoadBackdrop />}>
                            <Component {...props} />
                        </Suspense>
                    )
            }}
        />
    );
}


export default ProtectedRoutes;